
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import Utils from "models/helper/Utils";
import SequencerViewConfigSettingsContoller from "controllers/audioEditor/SequencerViewConfigSettingsContoller";
import SequencerViewConfigSettingsPopupView from "views/audioEditor/SequencerViewConfigSettingsPopupView";
import BottomSheet from "libs/bottomSheet/BottomSheet";
import RSVP from "rsvp";

const SequencerViewConfigSettingsPopupContoller = Chaplin.Controller.extend({

    initialize : function(options) {
        this.context = options? options.context: null;
        this.model = options.sequencer;
        this.elementSource$el =  options.elementSource$el;
        _.extend(this, Backbone.Events);
    },


    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },

    _onPopupClosed : function(){

    },


    buildModelAndRenderView : function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                this._sequencerViewConfigSettingsContoller = new SequencerViewConfigSettingsContoller({"sequencer":  this.model});

                this._sequencerViewConfigSettingsContoller.buildModelAndRenderView().then((function(){
                    if(window.isMobileBrowser){
                        //const bottomSheet = Utils.getInstance().createBottomSheet(this._sequencerNodeInspectorSectionController.getView().$el.get(0), resolve, this._onPopupClosed.bind(this));
                        const bottomSheet = new BottomSheet(this._sequencerViewConfigSettingsContoller.getView().$el.get(0), resolve, this._onPopupClosed.bind(this), true);
                        bottomSheet.activate();
                    }else{
                        const params = {"sequencerViewConfigSettingsView": this._sequencerViewConfigSettingsContoller.getView(),"elementSource$el": this.elementSource$el};
                        this.view = new SequencerViewConfigSettingsPopupView(params);
                        this.view.render();
                        this.listenTo(this.view, "onPopupClosed", this._onPopupClosed.bind(this))
                    }
                }).bind(this)).then(resolve).catch(reject);

            } catch (error) {
                reject(error);
            }

        }).bind(this));

    }

});

export default SequencerViewConfigSettingsPopupContoller;